if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();
        // Styloria: sharing is handled by styloria-lux.js via [data-styloria-share].
        // Keep this element as a light wrapper so product-info.js updateUrl still works.
        this.elements = {
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
        const btn = this.querySelector('[data-styloria-share]');
        if (btn) btn.dataset.shareUrl = url;
      }
    }
  );
}
